<template>
  <div class="sky-collect-template-link" prop="templateDownload" ref="formItem">
    <el-popover placement="right" class="el-form-item__tip sky-custom-description__popover el-popover__reference">
      <div>
        <div class="item-value">
          <a class="sk-link--text el-icon-download" @click="openUrl()"> 批量导入模版下载 </a>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script type="text/babel">
import { Button, Popover, Input } from 'element-ui'

import { COLLECT_REPORT } from '@/api/apiModules'
export default {
  name: 'SkyCollectTemplateLink',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Popover.name]: Popover
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {
    value: {
      handler: function(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    openUrl() {
      this.$store.dispatch('customDownloadDocument', {
        module: COLLECT_REPORT,
        params: {
          id: new Date().getTime()
        },
        action: 'downloadTemplate'
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(collect-template-link) {
  & .el-popper {
    position: relative;
    color: blue;
    display: inline-block !important;
    border: none !important;
    border-radius: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
  }
}
</style>
